import * as angular from 'angular';
import { PlannedDiplomaOptionsModalCtrl } from './planned-diploma-options.controller';
import { PlannedDiplomaOptionsModal } from './planned-diploma-options.service';

export const PlannedDiplomaOptionsModule = angular
  .module('plannedDiplomaOptions', [])
  .service('PlannedDiplomaOptionsModal', PlannedDiplomaOptionsModal)
  .controller('PlannedDiplomaOptionsModalCtrl', PlannedDiplomaOptionsModalCtrl).name;
